import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71a5696b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-10",
  src: "https://uploads-ssl.webflow.com/604926f0130bfcf3e366b5db/6079eb508b675583c1538362_Logo_Type_Blue.svg",
  alt: "LCA logo"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-4" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Ride Map")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("My Profile")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Admin")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Sign Out")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_split_pane, {
        "content-id": "main-content",
        when: "false"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, { "content-id": "main-content" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, { id: "inbox-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            "router-direction": "root",
                            "router-link": "/home",
                            lines: "none",
                            detail: "false",
                            class: "hydrated"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_2,
                      _createVNode(_component_ion_list_header, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.userProfile?.profile?.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_note, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.userProfile?.user?.email), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            "router-direction": "root",
                            "router-link": "/dashboard",
                            lines: "none",
                            detail: "false",
                            class: "hydrated"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                ios: _ctx.gridOutline,
                                md: _ctx.gridSharp
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            "router-link": "/map",
                            lines: "none",
                            detail: "false",
                            class: "hydrated"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                ios: _ctx.carOutline,
                                md: _ctx.carSharp
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_4
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            "router-link": "/profile",
                            lines: "none",
                            detail: "false",
                            class: "hydrated"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                ios: _ctx.readerOutline,
                                md: _ctx.readerSharp
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.userProfile?.isAdmin)
                        ? (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                            key: 0,
                            "auto-hide": "false"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                "router-link": "/admin",
                                lines: "none",
                                detail: "false",
                                class: "hydrated"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: _ctx.cogOutline,
                                    md: _ctx.cogSharp
                                  }, null, 8, ["ios", "md"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_7,
                      _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
                            lines: "none",
                            detail: "false",
                            class: "hydrated"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                ios: _ctx.logOutOutline,
                                md: _ctx.logOutSharp
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}